/// <reference path="./index.ts" />

/**
 * @module types/invoices/config
 * @description Configuration utilities for invoice providers
 */

export namespace Invoices {
  export namespace Config {
    /**
     * @namespace Defaults
     * @description Default configuration values for Invoice providers
     */
    export namespace Defaults {
      /**
       * @const DEFAULT_CLIENT_ID
       * @description Default client ID for new checkouts
       */
      export const DEFAULT_CLIENT_ID = process.env.INVOICED_API_DEFAULT_CLIENT_ID || '1';

      /**
       * @const DEFAULT_PROVIDER
       * @description Default invoice provider for new checkouts
       */
      export const DEFAULT_PROVIDER = 'invoiced';

      /**
       * @const DEFAULT_PLATFORM_ID
       * @description Default platform ID for new checkouts
       */
      export const DEFAULT_PLATFORM_ID = process.env.INVOICED_API_DEFAULT_PLATFORM_ID || '1008';

      /**
       * @const DEFAULT_TERRITORY_ID
       * @description Default territory ID for new checkouts
       */
      // export const DEFAULT_TERRITORY_ID = process.env.INVOICED_API_DEFAULT_TERRITORY_ID || 'US';
      export const DEFAULT_TERRITORY_ID =  process.env.INVOICED_API_DEFAULT_TERRITORY_ID || '10002';
    }

    /**
     * @namespace FeatureFlags
     * @description Feature flags for invoice behaviour
     */
    export namespace FeatureFlags {
      /**
       * @const SKIP_FREE_INVOICES
       * @description When true, bypass invoice/email generation for all $0 orders.
       */
      export const SKIP_FREE_INVOICES =
        process.env.REACT_APP_FEATURE_NO_FREE_INVOICES === 'true';
    }
  }
}
